import {Box, Typography} from '@mui/material';
import styled, {css} from 'styled-components';
import type {StyledTooltipTutorialProps} from './types';

const TooltipContainer = styled(Box)<StyledTooltipTutorialProps>`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 4px;
	width: ${({$customWidth}) => $customWidth ?? '250px'};
	padding: 16px 20px;
	${({theme}) => css`
		border-radius: 8px;
		background-color: ${theme.colors.brand.primary.white};
		filter: drop-shadow(0px 0px 16px rgba(4, 30, 66, 0.3));
	`}
`;

const Content = styled(Typography)`
	font-size: 1rem;
	line-height: 24px;

	color: ${({theme}) => theme.palette.text.primary};
`;

export {TooltipContainer, Content};
